import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/guard/auth.guard";
import { Role } from "./core/models/role";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { Page404Component } from "./authentication/page404/page404.component";
// import path from "path";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      
        {path: "user",
        canActivate: [AuthGuard],
        data: {
          role:Role.User,
        },
      },
       {path:"user",
       loadChildren: ()=>

      import("./user/user.module").then((m) => m.UserModule),},
      
  {
    path:"geographic-tracking",
    loadChildren: () =>
      import("./geographic-tracking/geographic-tracking.module").then((m) => m.GeographicTrackingModule),
  },
  {
    path:"population-health",
    loadChildren: () =>
      import("./population-health/population-health.module").then((m) => m.PopulationHealthModule),
  },

  {
    path:"onboarding",
    loadChildren: () =>
      import("./onboarding/onboarding.module").then((m) => m.OnboardingModule),
  },

{
  path: "dashboard",
  loadChildren: () =>
    import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
},

{
  path: "weather-data",
  loadChildren: () =>
    import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
},
{
  path: "alerts",
  loadChildren: () =>
    import("./alerts/alerts.module").then((m) => m.AlertsModule),
},

{
  path: "report-analytics",
  loadChildren: () =>
    import("./report-analytics/report-analytics.module").then((m) => m.ReportAnalyticsModule),
},

{
  path: "user-management",
  loadChildren: () =>
    import("./user-management/user-management.module").then((m) => m.UserManagementModule),
},

{
  path: "vetenary-management",
  loadChildren: () =>
    import("./vetenary-management/vetenary-management.module").then((m) => m.VetenaryManagementModule),
},
  

{
  path: 'onboarding/agro-veterinarians',
  loadChildren: () =>
    import('./onboarding/agro-veterinarians/agro-veterinarians.module')
      .then(m => m.AgroVeterinariansModule),
},
{ path: 'agro-veterinarians', loadChildren: () => import('./onboarding/agro-veterinarians/agro-veterinarians.module').then(m => m.AgroVeterinariansModule) },
{ 
  path: 'onboarding/farmers/search',
  loadChildren: () => import('./onboarding/farmers/search/search-farmer.module').then(m => m.SearchFarmerModule)
  //                                                         
},{ 
  path: 'onboarding/farmers/muzzle-downloads',
  loadChildren: () => import('./onboarding/farmers/muzzle-downloads/muzzle-downloads.module').then(m => m.MuzzleDownloadsModule)
  //                                                         
},{ 
  path: 'onboarding/farmers/validate',
  loadChildren: () => import('./onboarding/farmers/validate/validate-farmer.module').then(m => m.ValidateFarmerModule)
  //                                                         
},

{
  path: "reports",
  loadChildren: () =>
    import("./dashboard/reports/reports.module").then((m) => m.ReportsModule),
},
        
  
        
    ],
  },

  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
 
  { path: '**', component: Page404Component },


]

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
